<template>
  <div class="card-link-base">

    <section class="card-link-base-section">
      <div class="card-link-base-text">
        <h2>{{ linkName }}</h2>
        <hr>
        <p>{{ cardText }}</p>
      </div>
      <div class="card-link-base-cta">
        <s-button :class="btn" :btn-link="btnLink">{{msg}}</s-button>
      </div>
    </section>

  </div>
</template>

<script>

import SButton from "../components/SButton.vue";

export default {
  name: 'CardBase2',
  components: {
    SButton,
  },
  props: {
    btnLink: String,
    linkName: String,
    price: String,
    btn: String,
    cardText: String,
    msg: String
  }
}
</script>

<style scoped lang="scss">
@import "../styles/variables-screen-sizes";

.card-link-base {
  display: flex;
}

.card-link-base-section {
  max-width: 290px;
  height: auto;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 43px -4px rgba(0, 0, 0, .1);

  & > div {
    transition-duration: 0.3s;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;

    & > h2 {
      padding: 10px 0 0 0;
    }

    p {
      font-size: 1em;
      padding: 15px;
      height: 165px;
    }
  }
}

.card-link-base-text {
  & > hr {
    margin: 20px 35px;
    height: 0;
    border: 0;
    border-top: 1px solid #DFE5FC;
  }
}

.card-link-base-cta {
  display: flex;
  height: 158px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background: linear-gradient(0deg, rgba(237, 240, 252, 1) 0%, rgba(222, 228, 252, 1) 100%);

}

@media (max-width: $screen-pc-xs) {
  .button-secondary {
    width: 330px;
  }

  .button-primary-blue {
    width: 330px;
  }

  .card-link-base-section {
    max-width: 400px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 2px 43px -4px rgba(0, 0, 0, .1);

    .card-link-base-text {
      height: 280px;
      padding: 5px 0;
    }

    & > div {
      transition-duration: 0.3s;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      text-align: center;

      & > h1 {
        padding: 10px 0 0 0;
      }

      & > h2 {
        padding: 0;
      }
    }
  }

  .card-link-base-cta {
    height: 220px;
  }

}

</style>
